import React, {useEffect, useState} from 'react';
import CustomSelect from '../CustomSelect';
import {useDispatch} from 'react-redux';
import {setFields} from '../../store/builder/reducer';
import Input from '../Input';
import {useTranslation} from '../../hooks/useTranslation';

const FillDryRating = ({readOnly, disabled, item}) => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const [colorimetricScale, setColorimetricScale] = useState({
    id: 'colorimetric_scale',
    label: t('fillInspection.dryRating.colorimetricScale'),
    options: [
      {value: 'A', label: 'A'},
      {value: 'B', label: 'B'},
      {value: 'G', label: 'G'},
    ],
  });
  const [colorimetricGraduation, setColorimetricGraduation] = useState({
    id: 'colorimetric_graduation',
    label: t('fillInspection.dryRating.colorimetricGraduation'),
    options: [
      {value: '0', label: '0'},
      {value: '1', label: '1'},
      {value: '2', label: '2'},
      {value: '3', label: '3'},
      {value: '4', label: '4'},
      {value: '5', label: '5'},
      {value: '6', label: '6'},
      {value: '7', label: '7'},
      {value: '8', label: '8'},
      {value: '9', label: '9'},
      {value: '10', label: '10'},
    ],
  });
  const [particleAssessment, setParticleAssessment] = useState({
    id: 'particle_assessment',
    label: t('fillInspection.dryRating.particleAssessment'),
    options: [
      {value: 'A', label: 'A'},
      {value: 'B', label: 'B'},
      {value: 'C', label: 'C'},
      {value: 'D', label: 'D'},
      {value: 'E', label: 'E'},
      {value: 'F', label: 'F'},
      {value: 'G', label: 'G'},
      {value: 'H', label: 'H'},
      {value: 'I', label: 'I'},
    ],
  });
  const [wetOrDry, setWetOrDry] = useState({
    id: 'wet_or_dry',
    label: t('fillInspection.dryRating.wetOrDry'),
    options: [
      {value: 'W', label: t('fillInspection.dryRating.wet')},
      {value: 'D', label: t('fillInspection.dryRating.dry')},
    ],
  });
  const parseAnswersFromItem = (it) => {
    if (!it?.answers?.[0]) return { colorimetric_scale: null, colorimetric_graduation: null, particle_assessment: null, wet_or_dry: null };
    const parts = it.answers[0].split(',');
    return {
      colorimetric_scale: parts[0]?.trim() || null,
      colorimetric_graduation: parts[1]?.trim() || null,
      particle_assessment: parts[2]?.trim() || null,
      wet_or_dry: parts[3]?.trim() || null,
    };
  };
  const [answer, setAnswer] = useState(() => parseAnswersFromItem(item));
  const [finalAnswer, setFinalAnswer] = useState(null);

  useEffect(() => {
    if (!item?.answers?.[0]) return;
    const next = parseAnswersFromItem(item);
    setAnswer(prev => {
      if (
        prev?.colorimetric_scale === next.colorimetric_scale &&
        prev?.colorimetric_graduation === next.colorimetric_graduation &&
        prev?.particle_assessment === next.particle_assessment &&
        prev?.wet_or_dry === next.wet_or_dry
      ) {
        return prev;
      }
      return next;
    });
  }, [item?.id, item?.answers?.[0]]);

  useEffect(() => {
    setFinalAnswer(() => {
      let total;
      total =
        `${answer?.colorimetric_scale ? answer?.colorimetric_scale + ',' : ' ,'}` +
        `${answer?.colorimetric_graduation ? answer?.colorimetric_graduation + ',' : ' ,'}` +
        `${answer?.particle_assessment ? answer?.particle_assessment + ',' : ' ,'}` +
        `${answer?.wet_or_dry ? answer?.wet_or_dry : ' '}`;
      return total;
    });
  }, [answer]);

  useEffect(() => {
    if (readOnly || finalAnswer == null) return;
    const emptyPlaceholder = ' , , , ';
    if (finalAnswer === emptyPlaceholder) return;
    if (item?.answers?.[0] === finalAnswer) return;
    const fieldData = {
      ...item,
      id: item.id,
      answers: [`${finalAnswer}`],
    };
    dispatch(setFields(fieldData));
  }, [finalAnswer, readOnly, item?.id, item?.answers?.[0]]);

  const handleChange = e => {
    setAnswer({...answer, [e.target.id]: e.target.value});
  };

  return (
    <>
      <div className='fillInspection__field-select'>
        {readOnly ? (
          <>
            <div className='fillInspection__field-dry'>
              <Input
                label={colorimetricScale?.label}
                containerWidth={'220px'}
                value={item?.answers[0]?.split(',')[0]}
                readOnly={readOnly}
              />
              <Input
                label={colorimetricGraduation?.label}
                containerWidth={'220px'}
                value={item?.answers[0]?.split(',')[1]}
                readOnly={readOnly}
              />
              <Input
                label={particleAssessment?.label}
                containerWidth={'220px'}
                value={item?.answers[0]?.split(',')[2]}
                readOnly={readOnly}
              />
            </div>
            {/*<div className="fillInspection__field-dry">*/}
            {/*<Input label={wetOrDry?.label} containerWidth={'300px'} value={item?.answers[0]?.split(',')[3]} readOnly={readOnly} />*/}
            {/*</div>*/}
          </>
        ) : (
          <>
            <div className='fillInspection__field-dry'>
              <CustomSelect
                onChange={handleChange}
                name={colorimetricScale?.id}
                id={colorimetricScale?.id}
                label={colorimetricScale?.label}
                options={colorimetricScale?.options}
                maxwidth={'220px'}
                value={answer?.colorimetric_scale ?? ''}
              />
              <CustomSelect
                onChange={handleChange}
                name={colorimetricGraduation?.id}
                id={colorimetricGraduation?.id}
                label={colorimetricGraduation?.label}
                options={colorimetricGraduation?.options}
                maxwidth={'220px'}
                value={answer?.colorimetric_graduation ?? ''}
              />
              <CustomSelect
                onChange={handleChange}
                name={particleAssessment?.id}
                id={particleAssessment?.id}
                label={particleAssessment?.label}
                options={particleAssessment?.options}
                maxwidth={'220px'}
                value={answer?.particle_assessment ?? ''}
              />
            </div>
            {/*<div className="fillInspection__field-dry">*/}

            {/*<CustomSelect onChange={handleChange} name={wetOrDry?.id} id={wetOrDry?.id} label={wetOrDry?.label}*/}
            {/*              options={wetOrDry?.options} maxwidth={"300px"}/>*/}
            {/*</div>*/}
          </>
        )}
      </div>
    </>
  );
};

export default FillDryRating;
